//#region ng
import { NgModule } from '@angular/core';
import {
  CommonModule,
  NgOptimizedImage
} from '@angular/common';
//#endregion

//#region modules
import { CorBsComponentsModule } from '../_shared/_core/_ng-ui/_bs/cor-bs-components.module';
import { CorPipesModule } from '../_shared/_core/_ng/_pipes/cor-pipes.module';
//#endregion

//#region components
import {
  Horario2strComponent,
  ItemStatusBadgeComponent,
} from '.';
//#endregion

@NgModule({
  imports: [
    CorBsComponentsModule,
    CorPipesModule,
    CommonModule,
    NgOptimizedImage
  ],
  declarations: [
    Horario2strComponent,
    ItemStatusBadgeComponent,
  ],
  exports: [
    Horario2strComponent,
    ItemStatusBadgeComponent,
  ],
})
export class ComponentsModule { }
